export const ADD_SP = 'serviceprovider_profile/add_serviceprovider'

export const APPEND_ANSWERS_SP = 'serviceprovider_profile/append_answers'

export const ADD = 'serviceprovider_profile/add_serviceprovider'

export const APPEND_ANSWERS = 'serviceprovider_profile/append_answers'
